import React, { useState } from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { FormGroup, Label, ModalBody } from 'reactstrap'
import { useLocalization } from '@/hooks/localization'
import { DatePicker } from 'antd'

function SetValidRangeDialog (props) {
  const { localize } = useLocalization()

  const [validFrom, setValidFrom] = useState(null)
  const [validTo, setValidTo] = useState(null)

  return <React.Fragment>
    <BasicHeader title='' {...props} />
    <ModalBody>
      <FormGroup>
        <Label>{localize('Common.ValidFrom')}</Label>
        <DatePicker
          value={validFrom}
          onChange={value => setValidFrom(value)} />
      </FormGroup>
      <FormGroup>
        <Label>{localize('Common.ValidTo')}</Label>
        <DatePicker
          value={validTo}
          onChange={value => setValidTo(value)} />
      </FormGroup>
    </ModalBody>
    <ConfirmFooter primaryButtonText='Common.OK' icon='check' {...props} onAction={() => props.onAction({ validFrom, validTo })} />
  </React.Fragment>
}

export default {
  component: SetValidRangeDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/setValidRange.js